export default __webpack_public_path__ + "static/media/pic1.5a7f5c08.jpg";